(() => {
  const { routes, strings } = window.theme;
  const parse = (html) => new DOMParser().parseFromString(html, 'text/html');

  const updateCartCount = () => {
    const content = document.querySelector('[data-cart-drawer-content]');
    const count = Number(content?.dataset.itemCount || 0);
    document.querySelectorAll('[data-cart-count]').forEach((element) => {
      element.textContent = count;
      element.hidden = count === 0;
    });
  };

  const renderCartDrawer = (data) => {
    const html = data.sections?.['cart-drawer'];
    if (!html) return;
    const next = parse(html).querySelector('[data-cart-drawer-content]');
    const current = document.querySelector('[data-cart-drawer-content]');
    if (next && current) current.replaceWith(next);
    updateCartCount();
  };

  const readJson = async (response) => {
    const data = await response.json();
    if (!response.ok) throw new Error(data.description || data.message);
    return data;
  };

  const changeCartLine = async (button) => {
    const drawer = button.closest('[data-cart-drawer-content]');
    drawer.setAttribute('aria-busy', 'true');
    try {
      const response = await fetch(routes.cartChange, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          id: button.dataset.cartLine,
          quantity: Number(button.dataset.cartQuantity),
          sections: ['cart-drawer'],
        }),
      });
      renderCartDrawer(await readJson(response));
    } catch (error) {
      drawer.removeAttribute('aria-busy');
      const message = drawer.querySelector('[data-cart-error]');
      if (message) {
        message.textContent = error.message;
        message.hidden = false;
      }
    }
  };

  const addToCart = async (form) => {
    const button = form.querySelector('[name="add"]');
    const message = form.querySelector('[data-form-error]');
    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    message.hidden = true;
    try {
      const body = new FormData(form);
      body.append('sections', 'cart-drawer');
      const response = await fetch(routes.cartAdd, {
        method: 'POST',
        headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body,
      });
      renderCartDrawer(await readJson(response));
      const drawer = document.getElementById('CartDrawer');
      if (drawer && !drawer.open) drawer.showModal();
    } catch (error) {
      message.textContent = error.message;
      message.hidden = false;
    } finally {
      button.disabled = false;
      button.removeAttribute('aria-busy');
    }
  };

  const changeVariant = async (picker, input) => {
    const section = picker.closest('[data-product-section]');
    const variants = JSON.parse(picker.querySelector('[data-variants]').textContent);
    const selected = [...picker.querySelectorAll('input:checked')].map((item) => item.value);
    const changedIndex = [...picker.querySelectorAll('fieldset')].indexOf(input.closest('fieldset'));
    const sameValue = variants.filter((item) => item.options[changedIndex] === input.value);
    const variant =
      variants.find((item) => item.options.every((value, index) => value === selected[index])) ||
      sameValue.find((item) => item.available) ||
      sameValue[0];
    const button = section.querySelector('[name="add"]');

    if (!variant) {
      button.disabled = true;
      button.textContent = strings.unavailable;
      return;
    }

    const url = `${section.dataset.url}?variant=${variant.id}`;
    history.replaceState({}, '', url);
    section.setAttribute('aria-busy', 'true');
    const response = await fetch(`${url}&section_id=${section.dataset.sectionId}`);
    const next = parse(await response.text()).querySelector('[data-product-section]');
    if (!next) {
      section.removeAttribute('aria-busy');
      return;
    }
    const focusedId = document.activeElement?.id;
    section.replaceWith(next);
    if (focusedId) document.getElementById(focusedId)?.focus();
    window.Shopify?.PaymentButton?.init();
  };

  document.addEventListener('click', (event) => {
    const opener = event.target.closest('[data-dialog-open]');
    if (opener) {
      const dialog = document.getElementById(opener.dataset.dialogOpen);
      if (dialog) {
        event.preventDefault();
        dialog.showModal();
      }
      return;
    }

    if (event.target.closest('[data-dialog-close]')) {
      event.target.closest('dialog')?.close();
      return;
    }

    if (event.target instanceof HTMLDialogElement) {
      event.target.close();
      return;
    }

    const cartButton = event.target.closest('[data-cart-line]');
    if (cartButton) {
      changeCartLine(cartButton);
      return;
    }

    const step = event.target.closest('[data-quantity-step]');
    if (step) {
      const input = step.parentElement.querySelector('input');
      input.value = Math.max(Number(input.min || 1), Number(input.value || 1) + Number(step.dataset.quantityStep));
      return;
    }

    const thumb = event.target.closest('[data-thumb]');
    if (thumb) {
      document.getElementById(thumb.dataset.thumb)?.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
      return;
    }

    document.querySelectorAll('[data-dropdown][open]').forEach((dropdown) => {
      if (!dropdown.contains(event.target)) dropdown.open = false;
    });
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('[data-dropdown][open]').forEach((dropdown) => {
      dropdown.open = false;
    });
  });

  document.addEventListener('submit', (event) => {
    const form = event.target.closest('form[data-product-form]');
    if (!form) return;
    event.preventDefault();
    addToCart(form);
  });

  document.addEventListener('change', (event) => {
    const picker = event.target.closest('[data-variant-picker]');
    if (picker) {
      changeVariant(picker, event.target);
      return;
    }

    if (event.target.matches('[data-sort-select]')) {
      const url = new URL(window.location.href);
      url.searchParams.set('sort_by', event.target.value);
      url.searchParams.delete('page');
      window.location.assign(url);
      return;
    }

    const form = event.target.form;
    if (form?.matches('[data-auto-submit]') && !event.target.matches('textarea')) {
      form.requestSubmit();
    }
  });

  const desktop = window.matchMedia('(min-width: 990px)');
  const syncDesktopDetails = () => {
    document.querySelectorAll('[data-open-desktop]').forEach((details) => {
      details.open = desktop.matches;
    });
  };
  desktop.addEventListener('change', syncDesktopDetails);
  syncDesktopDetails();

  const recommendations = document.querySelector('[data-recommendations]');
  if (recommendations && recommendations.children.length === 0) {
    fetch(recommendations.dataset.url)
      .then((response) => response.text())
      .then((html) => {
        const next = parse(html).querySelector('[data-recommendations]');
        if (next) recommendations.innerHTML = next.innerHTML;
      })
      .catch(() => {});
  }
})();
